import { Component, computed, contentChild, inject, input } from '@angular/core';
import { KENDO_GRIDLAYOUT, KENDO_STACKLAYOUT } from '@progress/kendo-angular-layout';
import { SidebarTileDirective } from '@unity/directives/sidebar-tile.directive';
import { LayoutService } from '@unity/services/layout.service';

@Component({
  selector: 'unity-sidebar-layout',
  standalone: true,
  imports: [KENDO_GRIDLAYOUT, KENDO_STACKLAYOUT],
  templateUrl: './sidebar-layout.component.html',
  styleUrl: './sidebar-layout.component.scss',
})
export class SidebarLayoutComponent {
  private readonly layoutService = inject(LayoutService);

  private columns = 16;
  private singleWide = ['1fr'];

  private readonly $sidebarTileReference = contentChild(SidebarTileDirective);

  public readonly $sidebarSpan = input(3, { alias: 'sidebarSpan' });

  public readonly $sidebarMinWidth = input('20em', { alias: 'sidebarMinWidth' });

  private readonly $doubleWide = computed(() => {
    const sidebarSpan = this.$sidebarSpan();
    const sidebarMinWidth = this.$sidebarMinWidth();

    const mainSpan = this.columns - sidebarSpan;
    return [`${mainSpan}fr`, `minmax(${sidebarMinWidth}, ${sidebarSpan}fr)`];
  });

  protected readonly $sidebarLayoutGap = this.layoutService.$sidebarGridLayoutGap;
  protected readonly $sidebarConfig = this.layoutService.$sidebarConfig;

  protected readonly $colWidths = computed(() => {
    const doubleWide = this.$doubleWide();
    const sidebarConfig = this.$sidebarConfig();
    const sidebarTileReference = this.$sidebarTileReference();

    if (sidebarConfig.horizontal === false || sidebarTileReference === undefined) {
      return this.singleWide;
    }

    return doubleWide;
  });
}
